//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as LogsActions from './actions';
import { logToSentry } from "utils/networkErrorUtils";

//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- Create log ----------------
export const handleCreateLog = (data) => async(dispatch) => {
	// logs disable for temprory
	await dispatch(LogsActions.createLog());

	try {
		const logData = await apis.post('logsRDS', `/logs`, {
			body: { ...data }
		});

		await dispatch(LogsActions.createLogSuccess(logData));
	} catch (error) {
		logToSentry({
			message: 'Error creating log',
			error,
			module: 'LOGS',
			operation: 'CREATE_LOG'
		});
		await dispatch(LogsActions.createLogFail(error));
	}
};

//  -- List logs ----------------
export const handleListLogs = (startDate = undefined, endDate = undefined) => async(dispatch) => {
	await dispatch(LogsActions.listLogs());

	try {
		let logs = [];
		var url = `/logs`;

		if (startDate && endDate) {
			url += `?startDate=${startDate}&endDate=${endDate}`;
		}

		const logsRDS = await apis.get('logsRDS', url);

		if (Array.isArray(logsRDS) && logsRDS.length > 0) {
			logs = logsRDS
		}

		await dispatch(LogsActions.listLogsSuccess(logs));

		return logs;
	} catch (error) {
		if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'Error listing logs',
                error,
                module: 'LOGS',
                operation: 'LIST_LOGS'
            });
         }
		await dispatch(LogsActions.listLogsFail(error));
	}
};


export const handleAddInappropriateAlert = async (ckeck_word, currentUser, currentClass, location,text) => {
	try {
		const data = {
			word_used: ckeck_word.join(", "),
			userInfo: {
				id: currentUser.id,
				firstName: currentUser.firstName,
				lastName: currentUser.lastName,
				role: currentUser.role,
				org_id: currentUser.orgId
			},
			meta_data: {
				location,
				class_id: currentClass.id,
				class_name: currentClass.displayName,
				text
			},
			user_id: currentUser.id
		}
		const logData = await apis.post('logsRDS', `/inappropriate/add`, {
			body: data
		});
		return logData;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
				message: 'Error adding inappropriate alert',
				error,
				module: 'LOGS',
				operation: 'ADD_INAPPROPRIATE_ALERT'
			});
		}
	}
};
export const handleListInappropriateAlert = async (offset = 0, limit = 100) => {
	try {
		const logData = await apis.post('logsRDS', `/inappropriate/list`, {
			body: { offset, limit }
		});
		return logData;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
				message: 'Error listing inappropriate alert',
				error,
				module: 'LOGS',
				operation: 'LIST_INAPPROPRIATE_ALERT'
			});
		}
		return {}
	}
};
export const handleListLengthInappropriateAlert = async () => {
	try {
		const logData = await apis.get('logsRDS', `/inappropriate/get_length`);
		return logData;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
				message: 'Error listing length inappropriate alert',
				error,
				module: 'LOGS',
				operation: 'LIST_LENGTH_INAPPROPRIATE_ALERT'
			});
		}
		return {}
	}
};
export const handleArchiveInappropriateAlert = async (id) => {
	try {
		const logData = await apis.put('logsRDS', `/inappropriate/archive`,{
			body: { id }
		});
		return logData;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
				message: 'Error archiving inappropriate alert',
				error,
				module: 'LOGS',
				operation: 'ARCHIVE_INAPPROPRIATE_ALERT',
				tags: { id }
			});
		}
		return {}
	}
};
export const handleGetMoreInfoInappropriateAlert = async (id) => {
	try {
		const logData = await apis.post('logsRDS', `/inappropriate/getMoreInfo`,{
			body: { id }
		});
		return logData;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
				message: 'Error getting more info inappropriate alert',
				error,
				module: 'LOGS',
				operation: 'GET_MORE_INFO_INAPPROPRIATE_ALERT',
				tags: { id }
			});
		}
		return {}
	}
};

export const handleCreateTeacherSupportForm = async (data) => {
	try {
		const response = await apis.post('logsRDS', `/teacherSupportForm/create`, {
			body: data
		});
		return response;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
				message: 'Error creating teacher support form',
				error,
				module: 'LOGS',
				operation: 'CREATE_TEACHER_SUPPORT_FORM'
			});
		}
		throw error;
	}
};

export const handleListTeacherSupportForm = async (filters = {}) => {
	try {
		const response = await apis.get('logsRDS', `/teacherSupportForm/list`, {
			queryStringParameters: filters
		});
		return response;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
				message: 'Error listing teacher support forms',
				error,
				module: 'LOGS',
				operation: 'LIST_TEACHER_SUPPORT_FORM'
			});
		}
		return { data: [], total: 0 };
	}
};

export const handleUpdateTeacherSupportForm = async (id, data) => {
	try {
		const response = await apis.put('logsRDS', `/teacherSupportForm/${id}`, {
			body: data
		});
		return response;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
				message: 'Error updating teacher support form',
				error,
				module: 'LOGS',
				operation: 'UPDATE_TEACHER_SUPPORT_FORM'
			});
		}
		throw error;
	}
};